export function normalizePhoneForMask(phone: string): string {
  if (!phone) return ''

  const cleanPhone = phone.replace(/\D/g, '')

  if (cleanPhone.startsWith('55') && cleanPhone.length > 11) {
    return cleanPhone.substring(2)
  }

  return cleanPhone
}

export function normalizePhoneForAPI(phone: string): string {
  if (!phone) return ''

  const cleanPhone = phone.replace(/\D/g, '')

  if (!cleanPhone.startsWith('55') && cleanPhone.length >= 10) {
    return `55${cleanPhone}`
  }

  return cleanPhone
}
